<template>
  <div class="table" v-if="stageInfo" :class="{blur : (!$store.getters['user/data'].subsPlan)}">

    <app-btn
      to="/dashboard/plans"
      class="go-to-plans"
      v-if="!$store.getters['user/data'].subsPlan"
    >
      {{$ml.get(`Get the full access to the software`)}}
    </app-btn>

    <div class="side-fix">
      <div class="item">
        {{$ml.get(`Growth stage`)}}
      </div>
      <div class="item">
        {{$ml.get(`Duration`)}}
      </div>
      <div class="item" v-if="$store.getters['program/data'].type == 'hydroponic'">
        {{$ml.get(`EC`)}}
      </div>
      <div class="item" v-if="$store.getters['program/data'].type == 'hydroponic'">
        {{$ml.get(`pH`)}}
      </div>
      <div class="item" v-for="(item, i) in stageInfo[0].fertilizers" :key="i">
          {{$ml.get(item.name)}}
          <!-- ({{item.unit}}) -->
      </div>
      <div class="item">{{ $ml.get('Stage cost') }}</div>
    </div>
    <div>
      <carousel :pageCustom="pageCustom">
        <template v-for="(item, i) in stageInfo" >
          <div class="row" :key="i">
              <div class="stage-item">
                  {{$ml.get(item.name)}}
                  <info-tip :alert="true" :alerts="item" v-if="stageInfo.length"></info-tip>
              </div>
            <div>
              {{(item.duration || item.duration != '0 days') ? item.duration : '-'}}
            </div>
            <div v-if="$store.getters['program/data'].type == 'hydroponic'">
              {{item.ec.toFixed(2)}}
            </div>
            <div v-if="$store.getters['program/data'].type == 'hydroponic'">
              {{item.ph}}
            </div>
            <div v-for="(ferItem, j) in item.fertilizers" :key="j">
              <app-number-input
                v-if="manual"
                type="number"
                v-model="ferItem.concentration"
                :hint="ferItem.unit"
                @input="changeStage(i, ferItem)"
              />

              <div v-else-if="ferItem.concentration">
                <!-- {{ferItem.concentration}} -->
                <!-- {{ferItem.unit}} -->

                {{$store.getters['unit/isUnit'](ferItem.unit) ?
                  $store.getters['unit/convert'](ferItem.unit, ferItem.concentration) :
                  ferItem.concentration
                }}
                {{$store.getters['unit/isUnit'](ferItem.unit) ?
                  $store.getters['unit/getLabel'](ferItem.unit) :
                  ferItem.unit
                }}
                <div class="cost" v-if="ferItem.cost">
                  {{ $store.getters['user/currency'].symbol }}
                  {{ ferItem.cost.toFixed(2) }}      
                </div>
              </div>
              <div v-else>-</div>
            </div>

            <div v-if="item.cost">{{ $store.getters['user/currency'].symbol }} {{ item.cost }}</div>
            <div v-else>-</div>
          </div>
        </template>
      </carousel>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/common/carousel/Carousel';

export default {
  props: {
    stageInfo: Array,
    manual: Boolean,
  },
  components: {
    Carousel
  },
  data() {
    return {
      stageInput: null,
      ferItem: null,
      pageCustom: [
        [0, 1],
        [780, 2],
        [895, 3],
        [1100, 4],
        [1500, 5]
      ]
    }
  },
  watch: {
    manual: function (val) {
      if (!val && this.stageInput != null) {
        if (this.$store.getters['program/data'].type == 'hydroponic' && this.ferItem.stateId == 3) {
          this.stageInfo[this.stageInput].fertilizers.map(fert => {
            if (fert.id != this.ferItem.id && fert.stateId == 3) {
              fert.concentration = 0;
            }
          });
        }

        this.$emit('input', this.stageInfo);
        this.$emit('change', this.stageInput);

        this.stageInput = null;
        this.ferItem = null;
      }
    }
  },
  methods: {
    changeStage: function (index, ferItem) {
      this.stageInput = index;
      this.ferItem = ferItem;
    }
  },
}
</script>

<style lang="scss" scoped>
.table {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: stretch;

  .stage-item{
    position: relative;
    top: 0;
    left: 0;
    display: flex;

    .helper-question-mark{
      // position: absolute;
      // top: 80%;
      // left: 44%;
      // transform: translate(-50%, -50%);
    }
  }

  .side-fix {

    display: flex;
    flex-direction: column;

    min-width: 200px;

    .item {
      height: 64px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      font-size: 13px;
      border-bottom: 1px solid #eee;
    }
  }

  > div:last-child {
    width: calc(100% - 200px);
  }
  .row {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .text-input::v-deep input {
      width: 100px;
    }
    > div {
      width: 100%;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      font-weight: normal;
      font-size: 16px;
      font-family: Roboto;
      font-style: normal;
      border-bottom: 1px solid #eee;
      text-align: center;

      &:first-child {
        font-weight: bold;
        font-size: 16px;
        color: #000;
        padding: 0 25px;
      }

      input {
        width: 100px;
        color: $mainGreen;
        border-radius: 3px;
        box-shadow: none;
        border: solid 1px #bebebe;
        line-height: 1;
        padding: 3px 5px;
        font-weight: 500;
        text-align: center;

        /* Chrome, Safari, Edge, Opera */
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        &[type=number] {
          -moz-appearance:textfield;
        }
      }
      .cost {
        padding-top: 4px;
      }
    }
  }
  @media (max-width: 768px) {
    .side-fix {
      min-width: unset;
    }
    > div:last-child {
      flex-grow: 1;
    }
  }
  @media (max-width: 1200px) {
    .stage-item {
      font-size: 15px;
    }
  }
}

</style>
